import { SurgeonDashboardData } from '@/models/surgeonDashboard';
import { signedApiClient } from './apiClient';


class SurgeonDashboardService {

  initService() {}

  async getSurgeonDashboardData(caseId: string) {
    const uri = `pump/case/${caseId}/perfusion-data`;
    const apiClient = signedApiClient('GET', uri);
    const response = await apiClient.get(uri);
    return SurgeonDashboardData.mapFromBackend(response.data);
  }

  async getPerfusionSummaryData(caseId: string) {
    const uri = `pump/case/${caseId}/perfusion-data/summary`;
    const apiClient = signedApiClient('GET', uri);
    const response = await apiClient.get(uri);
    return SurgeonDashboardData.mapFromBackend(response.data);
  }

  async getPerfusionGasesData(caseId: string) {
    const uri = `pump/case/${caseId}/perfusion-data/gases`;
    const apiClient = signedApiClient('GET', uri);
    const response = await apiClient.get(uri);
    return SurgeonDashboardData.mapFromBackend(response.data);
  }

  async getPerfusionFlowsData(caseId: string) {
    const uri = `pump/case/${caseId}/perfusion-data/flows`;
    const apiClient = signedApiClient('GET', uri);
    const response = await apiClient.get(uri);
    return SurgeonDashboardData.mapFromBackend(response.data);
  }

  async getPerfusionLabsData(caseId: string) {
    const uri = `pump/case/${caseId}/perfusion-data/labs`;
    const apiClient = signedApiClient('GET', uri);
    const response = await apiClient.get(uri);
    return SurgeonDashboardData.mapFromBackend(response.data);
  }

  async getPerfusionBileData(caseId: string) {
    const uri = `pump/case/${caseId}/perfusion-data/bile`;
    const apiClient = signedApiClient('GET', uri);
    const response = await apiClient.get(uri);
    return SurgeonDashboardData.mapFromBackend(response.data);
  }

  async getInteractiveSurgeonDashboardData(caseId: string, variable?: string, postFilters?: Record<string, string>) {
    let uri = `pump/case/${caseId}/interactive-perfusion-data`;
    if (variable) {
      uri += `?variable=${variable}`;
      Object.keys(postFilters ?? {}).forEach(key => {
        uri += `&${key}=${encodeURIComponent(postFilters![key])}`;
      });
    } else if (postFilters) {
      uri += '?';
      Object.keys(postFilters).forEach(key => {
        uri += `${key}=${encodeURIComponent(postFilters[key])}&`;
      });
      uri = uri.slice(0, -1);
    }
    const apiClient = signedApiClient('GET', uri);
    const response = await apiClient.get(uri);
    if (variable) {
      return response.data;
    }
    return SurgeonDashboardData.mapFromBackend(response.data);
  }

  async getPumpQcReportsToken(studyId: string) {
    const uri = `pump/study/${studyId}/qc-reports-token`;
    const apiClient = signedApiClient('GET', uri);
    const response = await apiClient.get(uri);
    return response.data as {
      token: string;
      role: string;
      allowed_centers: string[];
    };
  }

}

export default new SurgeonDashboardService();
